import { ArrowRight } from "lucide-react";
import { useViewer } from "./viewerStore";
import { BOOTCAMP_URL, CHALLENGE_URL, reportIntent } from "./cta";

const SKOOL_URL = "https://www.skool.com/love-vortex-6983/about";

const PathCard = ({ id, tier, label, title, children, href, cta, intent, external }) => (
  <article className={`path path-${tier}`} data-testid={`path-${id}`}>
    <p className="path-label">{label}</p>
    <h3 className="path-title">{title}</h3>
    <div className="path-body">{children}</div>
    <a href={href} onClick={() => reportIntent(intent)} className="path-btn" data-testid={`path-${id}-button`} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
      <span>{cta}</span> <ArrowRight size={16} />
    </a>
  </article>
);

export const NextPaths = () => {
  const { email } = useViewer();
  if (!email) return null;
  return (
    <section className="sec paths-sec" data-testid="next-paths-section">
      <p className="paths-kicker">You’ve seen the path.</p>
      <h2 className="paths-h">Now choose how deep you want to go.</h2>
      <div className="paths">
        <PathCard id="free" tier="free" label="Keep learning — Free" title="Love University" href={SKOOL_URL} intent="love" cta="Enter Love University — Free" external>
          <p>Re-watch the class anytime, go deeper into Dasha’s work and bring someone you love with you.</p>
          <p><b>Love University is free.</b></p>
          <p>Watch it again. Share it with your partner, friend or business partner. Let the idea actually land.</p>
        </PathCard>
        <PathCard id="diy" tier="diy" label="Build it yourself — $100" title="$100K Book Bootcamp" href={BOOTCAMP_URL} intent="bootcamp" cta="Get the complete DIY system — $100">
          <p>Ready to turn your belief-shifting idea into a real business asset?</p>
          <p>Learn how to <b>speak your book, build the offer behind it and create the AI-powered backend yourself.</b></p>
          <p className="path-contrast"><b>The free class shows you the model.</b><br /><b>The $100K Book Bootcamp gives you the complete DIY system.</b></p>
          <p>For the action-taker who wants the trainings, tools and system — and is ready to implement independently.</p>
        </PathCard>
        <PathCard id="dasha" tier="dasha" label="Build it with Dasha — $2,000" title="8-Week NO BS Consistent Cash Challenge" href={CHALLENGE_URL} intent="dasha" cta="Implement my WTF idea">
          <p>You understand the model. <b>Now let’s build yours.</b></p>
          <p>Spend 8 weeks implementing your <b>WTF idea → unique method → book → premium offer → AI-powered Freedom Funnel → consistent cash</b> with Dasha’s support.</p>
          <p className="path-contrast"><b>Yes — your book can get done during the 8-week challenge too.</b></p>
          <p>This is not another information course. It’s the implementation path for the person saying: <i>“I understand what I need to build. Now help me actually build the damn thing.”</i></p>
        </PathCard>
      </div>
    </section>
  );
};
